module.exports = __webpack_public_path__ + "static/media/csv.561c1678.png";